/**
 * Build a URL for the `icon://` protocol, which serves app icons out of the on-disk
 * Icon Cache. Cache filenames are lowercased with `.exe` stripped (see
 * `normalizeAppName` in `SystemWindows.ts`), and the name must be percent-encoded —
 * an unescaped space makes `new URL()` throw in the protocol handler, which renders
 * as a broken image.
 */
export const appIconUrl = (appName: string | undefined | null): string | undefined => {
  const normalized = appName
    ?.trim()
    .toLowerCase()
    .replace(/\.exe$/, '')
  return normalized ? `icon://${encodeURIComponent(normalized)}` : undefined
}
